import { Route } from 'vue-router';

import { AttachmentType } from '@/enums/attachmentType.enum';
import { EntityType } from '@/enums/entityType.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { procedureDetailsRoute } from '@/router/mainRoute/procedureRoute/details.route';
import store from '@/store/store';
import { tryParseInt } from './number';

/**
 * Pobiera dane procedury
 *
 * @returns {Promise<any>}
 * @export
 */
export function getProcedureViewData(route: Route): Promise<any> {
  store.commit('procedure/setId', tryParseInt(route.params.procedureId));
  const entityId = route.params.procedureId.toString();
  const entityType = EntityType.PROCEDURE;
  return store.dispatch('procedure/get').then(() =>
    Promise.all([
      store.dispatch('button/list', { statusId: store.state.procedure.data.status.id, count: -1 }),
      store.dispatch('procedure/attachment/list', {
        order: 'order',
        desc: false,
        count: -1,
        entityType,
        entityId,
        type: AttachmentType.UPLOADED
      }),
      store
        .dispatch('setting/findPublic', { code: PublicSettings.GDPR_INFO_CLAUSE, entityType, entityId })
        .then(setting =>
          store.dispatch('setting/attachment/list', { entityType: EntityType.SETTING, entityId: setting.id.toString() })
        )
        .catch(() => undefined)
    ])
  );
}

export function getProcedureDetailsData(route: Route): Promise<any> {
  store.commit('procedure/setId', tryParseInt(route.params.procedureId));
  const entityId = route.params.procedureId.toString();
  const entityType = EntityType.PROCEDURE;
  return Promise.all([
    store.dispatch('procedure/get').then(procedure => {
      if (route.query.parentId && route.query.parentProcedureId) {
        procedureDetailsRoute.meta.breadcrumb.title = 'Ocena';
        procedureDetailsRoute.meta.breadcrumb.name = 'documentList';
        route.meta.title = procedure.name = 'Ocena';
      } else {
        procedureDetailsRoute.meta.breadcrumb.title = procedure.name;
        procedureDetailsRoute.meta.breadcrumb.name = 'procedureView';
        route.meta.title = procedure.name;
      }
    }),
    store.dispatch('procedure/getTabs', { entityId, entityType }),
    store.dispatch('setting/publicList', {
      codes: [
        PublicSettings.CHILD_PROCEDURE_ID,
        PublicSettings.DECISION_REPORT_COLUMNS,
        PublicSettings.DOCUMENT_ATTACHMENT_VIEW_IDS,
        PublicSettings.DOCUMENT_RENDER_OPTIONS,
        PublicSettings.DOCUMENT_VIEW_ID,
        PublicSettings.FINANCIAL_REPORT_COLUMNS,
        PublicSettings.HIDE_PROCEDURE_DOCUMENTATION,
        PublicSettings.HIDE_PROCEDURE_DOCUMENTATION_FOR_JO,
        PublicSettings.HIDE_PROCEDURE_GENERATE_FOR_JO,
        PublicSettings.PACK_ENABLED,
        PublicSettings.PROCEDURE_VIEW_IDS,
        PublicSettings.RENDER_EMPTY_OPTIONS,
        PublicSettings.RENDER_VIEW_OPTIONS,
        PublicSettings.REPORT_COLUMNS,
        PublicSettings.REPORT_FILTERS,
        PublicSettings.REPORT_GROUPS,
        PublicSettings.STATISTICS_COLUMNS,
        PublicSettings.DISABLE_MDOK_IMPORT_EXTRA_FIELDS
      ],
      entityId,
      entityType
    })
  ]);
}
